const EXIT_FALLBACK_MS = 1000;

/**
 * Runs `done` once the element's exit animations have ended. Without a running
 * animation (reduced motion, a test DOM) that is at once, and a stuck one is
 * capped so nothing can linger closed. The returned function disarms the run,
 * for an element that reopens mid-exit: a cancelled animation still settles.
 */
export function afterExit(element: Element | null, done: () => void): () => void {
   const animations = element?.getAnimations?.() ?? [];
   if (animations.length === 0) {
      done();
      return () => {};
   }
   let isDisarmed = false;
   const finish = () => {
      if (isDisarmed) return;
      isDisarmed = true;
      done();
   };
   void (async () => {
      await Promise.allSettled(animations.map(animation => animation.finished));
      finish();
   })();
   const fallback = setTimeout(finish, EXIT_FALLBACK_MS);
   return () => {
      isDisarmed = true;
      clearTimeout(fallback);
   };
}
